import { isPlanEnterprise, isPlanPlus } from "@/react/helpers/planHelpers";
import { usePunditUserContext } from "@circle-react/contexts";

export const useAiSummariesEnabled = (): boolean => {
  const { currentCommunitySettings, currentCommunity } = usePunditUserContext();
  const currentPlanTier = currentCommunity?.current_plan_tier || "";

  return Boolean(
    currentCommunitySettings?.ai_spaces_summaries_enabled &&
      (isPlanEnterprise(currentPlanTier) || isPlanPlus(currentPlanTier)),
  );
};
